/* eslint-disable max-len */
import forEach from 'lodash/forEach';

import urlSearch from './urlSearch';

import { getFilter } from './filters';

export default ({ data, params = urlSearch.getParams(window.location.search) }) => {
  const APPLIED_FILTERS = {};

  const paramMapper = (value, key) => {
    if (APPLIED_FILTERS[key]) {
      if (Array.isArray(APPLIED_FILTERS[key])) {
        APPLIED_FILTERS[key] = [...APPLIED_FILTERS[key], value];
      } else {
        APPLIED_FILTERS[key] = [APPLIED_FILTERS[key], value];
      }
    } else {
      APPLIED_FILTERS[key] = value;
    }
  };

  // URLSearchParams has forEach method, regular objects do not - this handles both
  if (params.forEach) params.forEach(paramMapper);
  else forEach(params, paramMapper);

  return data.filter((item) => {
    let isValidSearchResult = true;

    forEach(APPLIED_FILTERS, (filterValue, filterKey) => {
      const filterMethod = getFilter(filterKey);
      if (isValidSearchResult && filterMethod) isValidSearchResult = filterMethod(item, filterValue);
    });

    return isValidSearchResult;
  });
};
